import { createApp, ref } from 'vue'
import login from './Registration/Login.vue'

import "./assets/style.scss";
import "./registerValidators"
import { initGlobalProperties } from './initGlobalProperties';

 const app = createApp(login)
 initGlobalProperties(app);
  app.mount('#app');
  
  window.console.log("login");



